// extracted by mini-css-extract-plugin
export default {"loader":"_loadercircle_loader__WrqL0","rotation":"_loadercircle_rotation__9YQBJ"};